import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=e4a5dc68&scoped=true&"
import script from "./InfoPanel.vue?vue&type=script&lang=js&"
export * from "./InfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=e4a5dc68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a5dc68",
  null
  
)

export default component.exports